"use strict";

exports.__esModule = true;
exports.breakpointUp = exports.breakpointOnly = exports.breakpointDown = exports.breakpointBetween = void 0;

var _styledComponents = require("styled-components");

var _polished = require("polished");

var _theme = _interopRequireDefault(require("../theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const {
  breakpoints
} = _theme.default;

const mediaBreakpointUp = size => styles => (0, _styledComponents.css)`
    @media (min-width: ${size}px) {
        ${styles}
    };`;

const mediaBreakpointDown = size => styles => (0, _styledComponents.css)`
    @media (max-width: ${size - 1}px) {
        ${styles}
    };`;

const mediaBreakpointBetween = (min, max) => styles => (0, _styledComponents.css)`
    @media (min-width: ${min}px) and (max-width: ${max - 1}px) {
        ${styles}
    };`; // Bootstrap style helper method for adding mobile-first (up) responsive breakpoint in styled-components


const breakpointUp = Object.keys(breakpoints).reduce((accumulator, label) => {
  accumulator[label] = (...args) => {
    const size = (0, _polished.stripUnit)(breakpoints[label]);
    return mediaBreakpointUp(size)((0, _styledComponents.css)(...args));
  };

  return accumulator;
}, {}); // Bootstrap style helper method for adding desktop-first (down) responsive breakpoint in styled-components

exports.breakpointUp = breakpointUp;
const breakpointDown = Object.keys(breakpoints).reduce((accumulator, label) => {
  accumulator[label] = (...args) => {
    let size;

    switch (label) {
      case 'xxs':
        size = (0, _polished.stripUnit)(breakpoints['xs']);
        break;

      case 'xs':
        size = (0, _polished.stripUnit)(breakpoints['sm']);
        break;

      case 'sm':
        size = (0, _polished.stripUnit)(breakpoints['md']);
        break;

      case 'md':
        size = (0, _polished.stripUnit)(breakpoints['lg']);
        break;

      case 'lg':
        size = (0, _polished.stripUnit)(breakpoints['xl']);
        break;

      default:
        size = 0;
    }

    return mediaBreakpointDown(size)((0, _styledComponents.css)(...args));
  };

  return accumulator;
}, {}); // Bootstrap style helper method for adding styles that only apply at a single responsive breakpoint in styled-components

exports.breakpointDown = breakpointDown;
const breakpointOnly = Object.keys(breakpoints).reduce((accumulator, label) => {
  accumulator[label] = (...args) => {
    if (label === 'xxs') {
      return mediaBreakpointDown((0, _polished.stripUnit)(breakpoints['xs']))((0, _styledComponents.css)(...args));
    } else if (label === 'xl') {
      return mediaBreakpointUp((0, _polished.stripUnit)(breakpoints['xl']))((0, _styledComponents.css)(...args));
    } else {
      const min = (0, _polished.stripUnit)(breakpoints[label]);
      let max;

      switch (label) {
        case 'xxs':
          max = (0, _polished.stripUnit)(breakpoints['xs']);
          break;

        case 'xs':
          max = (0, _polished.stripUnit)(breakpoints['sm']);
          break;

        case 'sm':
          max = (0, _polished.stripUnit)(breakpoints['md']);
          break;

        case 'md':
          max = (0, _polished.stripUnit)(breakpoints['lg']);
          break;

        case 'lg':
          max = (0, _polished.stripUnit)(breakpoints['xl']);
          break;

        default:
          max = 0;
      }

      return mediaBreakpointBetween(min, max)((0, _styledComponents.css)(...args));
    }
  };

  return accumulator;
}, {}); // Bootstrap style helper method for adding styles that apply between two responsive breakpoints in styled-components

exports.breakpointOnly = breakpointOnly;

const breakpointBetween = (min, max) => (...args) => mediaBreakpointBetween((0, _polished.stripUnit)(breakpoints[min]), (0, _polished.stripUnit)(breakpoints[max]))((0, _styledComponents.css)(...args));

exports.breakpointBetween = breakpointBetween;